// import React from "react";
import React, { useEffect, useRef, useState } from "react";
import { Pagination } from "react-bootstrap";
import {
  ArrowDown,
  ArrowUp,
  CaretDownSquareFill,
  GearFill,
  Search,
} from "react-bootstrap-icons";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  useRowSelect,
} from "react-table";
import TdLoader from "../common/TdLoader";
import GlobalFilter from "./GlobalFilter";
import "./style/style.css";
import { useTranslation } from "react-i18next";
import FormatNumber from "../common/NumberFormat";

const PaginatedTable = (props) => {
  const { t } = useTranslation();

  const {
    columns,
    data: {
      data,
      limit,
      page: pageIndex,
      total,
      totalPages,
      aggregate,
      nextCursor,
      previousCursor,
    },
    isLoading,
    customComponent,
    bulkLength,
    // pageIndex,
    // setPageIndex,
    // pageSize,
    // setPageSize,
    callTableQueryApi,
    aggregatePermission,
  } = props;

  const [tablePageIndex, setTablePageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [isFullTable, setIsFullTable] = useState(false);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    prepareRow,
    gotoPage,
    pageCount,
    // setPageSize,
    state,
    setGlobalFilter,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
    rows,
  } = useTable(
    {
      columns,
      data,
      autoResetGlobalFilter: false,
      manualPagination: true,
      pageCount: totalPages,
      initialState: {
        pageIndex,
        pageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
  );
  const {
    globalFilter,
    // pageIndex, pageSize
  } = state;

  // useEffect(() => {
  //   if (pageIndex >= totalPages && totalPages > 0) {
  //     setPageIndex(totalPages - 1);
  //     localStorage.setItem("total", total);
  //     localStorage.setItem("totalPages", totalPages);
  //     localStorage.setItem("aggregate", JSON.stringify(aggregate));
  //   }
  // }, [totalPages]);

  // const total = localStorage.getItem("total");
  // const totalPages = localStorage.getItem("totalPages");
  // const localAggregate = JSON.parse(localStorage.getItem("aggregate"));

  //   useEffect(() => {
  //     setPageSize(100);
  //   }, []);

  useEffect(() => {
    if (props.bulkState) {
      props?.bulkState.setBulkCustomer(selectedFlatRows);
    }
  }, [selectedFlatRows]);
  const [isActive, setIsActive] = useState(false);
  const [isPagination, setIsPagination] = useState(false);
  const toggleColumnRef = useRef();

  const handleToggleColumn = () => {
    setIsActive(!isActive);
  };

  const paginationHandler = () => {
    setIsPagination(!isPagination);
  };

  const [searchValue, setSearchValue] = useState("");

  // Input change handler
  const handleChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleTableQuerySubmit = ({
    tablePageIndex,
    pageSize,
    isFullTable,
    search,
  }) => {
    const query = {
      total,
      totalPages,
      search: search?.trim(),
      ...(!isFullTable && !pageSize && tablePageIndex > pageIndex
        ? { nextCursor }
        : {}),
      ...(!isFullTable && !pageSize && tablePageIndex < pageIndex
        ? { previousCursor }
        : {}),
    };

    if (!isLoading) {
      callTableQueryApi({
        page: tablePageIndex,
        limit: pageSize,
        ...query,
      });
    }
  };

  // Enter press support
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleTableQuerySubmit({ search: searchValue });
    }
  };

  return (
    <>
      <div className="childCollector">
        <div className="d-flex align-items-center">
          <div>
            <div ref={toggleColumnRef} className="toggle-column-header w-100">
              <div
                className="d-flex justify-content-center align-items-center ms-1"
                style={{ marginTop: "-5px" }}
              >
                <div id="toggle_selection" className="toggle-setting">
                  <div className="text-white me-2" onClick={handleToggleColumn}>
                    <GearFill />
                  </div>

                  <div
                    className={`toggle-column-modal ${isActive && "active"}`}
                  >
                    <div class="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        {...getToggleHideAllColumnsProps()}
                      />
                      <label class="form-check-label">Show All</label>
                    </div>

                    {allColumns.map((item) => (
                      <div class="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          {...item.getToggleHiddenProps()}
                        />
                        <label class="form-check-label">{item.Header}</label>
                      </div>
                    ))}
                  </div>
                </div>

                {totalPages > 1 && (
                  <div id="toggle_selection" className="toggle-pagination">
                    <div
                      className="text-white me-2"
                      onClick={paginationHandler}
                      title={t("totalPages")}
                    >
                      <CaretDownSquareFill />
                    </div>

                    <div
                      className={`toggle-column-modal-pagination ${
                        isPagination && "active"
                      }`}
                    >
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onClick={(e) =>
                          handleTableQuerySubmit({
                            tablePageIndex: 1,
                            pageSize: Number(e.target.value),
                            isFullTable: false,
                          })
                        }
                      >
                        {[100, 200, 500, 1000].map((pageSize) => (
                          <option key={pageSize} value={pageSize}>
                            {pageSize}
                          </option>
                        ))}
                      </select>

                      <div className="w-100s">
                        <Pagination
                          aria-label="Page navigation example"
                          className="pagination"
                        >
                          <Pagination.First
                            disabled={pageIndex === 1}
                            onClick={() =>
                              handleTableQuerySubmit({
                                tablePageIndex: 1,
                                isFullTable: true,
                              })
                            }
                          ></Pagination.First>
                          <Pagination.Prev
                            disabled={pageIndex === 1}
                            onClick={() =>
                              handleTableQuerySubmit({
                                tablePageIndex: pageIndex - 1,
                                isFullTable: false,
                              })
                            }
                          />

                          <Pagination.Item active>{pageIndex}</Pagination.Item>

                          <Pagination.Next
                            disabled={pageIndex === totalPages}
                            onClick={() =>
                              handleTableQuerySubmit({
                                tablePageIndex: pageIndex + 1,
                                isFullTable: false,
                              })
                            }
                          />

                          <Pagination.Last
                            disabled={pageIndex === totalPages}
                            onClick={() =>
                              handleTableQuerySubmit({
                                tablePageIndex: totalPages,
                                isFullTable: true,
                              })
                            }
                          />
                        </Pagination>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <h6 className="allCollector">
            {t("totalData")}
            <span>
              {total} {bulkLength ? `/ ${bulkLength}` : ""}
            </span>
          </h6>

          <div id="custom_component_data">
            <div
              className="text-center"
              style={{ fontSize: "18px", fontWeight: "500", display: "flex" }}
            >
              {aggregatePermission &&
                aggregate &&
                Object.keys(aggregate)?.map(
                  (key) =>
                    aggregate[key] > 0 && (
                      <div style={{ marginRight: "10px" }}>
                        {t(key)}: ৳{FormatNumber(aggregate[key])}
                      </div>
                    ),
                )}
            </div>
          </div>
        </div>

        <div class="col-sm-4 search-section">
          <div class="search-container">
            <input
              type="text"
              class="search-input"
              id="searchInput"
              placeholder="Search"
              autocomplete="off"
              value={searchValue}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            <button
              class="search-btn"
              id="searchButton"
              onClick={() => handleTableQuerySubmit({ search: searchValue })}
            >
              <Search />
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive-lg">
        <table
          className="table table-striped table-borderless"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    {...column.getHeaderProps({
                      style: { width: column.width, cursor: "pointer" },
                    })}
                  >
                    {column.render("Header")}

                    {column.id === "option" ||
                    column.id === "option1" ||
                    column.id === "selection" ? (
                      ""
                    ) : (
                      <>
                        <ArrowDown
                          className={`arrowDown sorting-data text-primary ${
                            column.isSorted &&
                            (column.isSortedDesc ? "" : "text-danger")
                          } `}
                        />
                        <ArrowUp
                          className={`arrowUp sorting-data text-primary ${
                            column.isSorted &&
                            (column.isSortedDesc ? "text-danger" : "")
                          } `}
                        />
                      </>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          {!data?.length && isLoading ? (
            <TdLoader colspan={columns.length} />
          ) : data?.length > 0 ? (
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);

                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell, i) => {
                      return (
                        <td
                          {...cell.getCellProps({
                            style: {
                              width: cell.column.width,
                            },
                          })}
                          key={i}
                          className="align-middle"
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tr>
              <td colSpan={columns.length}>
                <h5 className="text-center"> {t("noDataFound")} </h5>
              </td>
            </tr>
          )}
        </table>
      </div>

      {totalPages + pageIndex - 1 > 1 && (
        <div className="d-flex justify-content-between">
          <div className="col-md-2">
            <select
              className="form-select"
              aria-label="Default select example"
              onClick={(e) =>
                handleTableQuerySubmit({
                  tablePageIndex: 1,
                  pageSize: Number(e.target.value),
                  isFullTable: false,
                })
              }
            >
              {[100, 200, 500, 1000].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </div>

          <Pagination aria-label="Page navigation example">
            <Pagination.First
              disabled={pageIndex === 1}
              onClick={() =>
                handleTableQuerySubmit({ tablePageIndex: 1, isFullTable: true })
              }
            ></Pagination.First>
            <Pagination.Prev
              disabled={pageIndex === 1}
              onClick={() =>
                handleTableQuerySubmit({
                  tablePageIndex: pageIndex - 1,
                  isFullTable: false,
                })
              }
            />

            <Pagination.Item active>{pageIndex}</Pagination.Item>
            <Pagination.Item>of</Pagination.Item>
            <Pagination.Item>{totalPages}</Pagination.Item>

            <Pagination.Next
              disabled={pageIndex === totalPages}
              onClick={() =>
                handleTableQuerySubmit({
                  tablePageIndex: pageIndex + 1,
                  isFullTable: false,
                })
              }
            />

            <Pagination.Last
              disabled={pageIndex === totalPages}
              onClick={() =>
                handleTableQuerySubmit({
                  tablePageIndex: totalPages,
                  isFullTable: true,
                })
              }
            />
          </Pagination>
        </div>
      )}
    </>
  );
};

export default React.memo(PaginatedTable);
